// returns a random integer in range [a,b)
export function randRange(a, b) {
   let rand = Math.random();
   return a + Math.floor(rand * (b - a));
}

export function randArray(arr) {
   return arr[randRange(0, arr.length)];
}

export function getDate() {
   const today = new Date();
   const date =
      today.getFullYear() +
      "\\" +
      (today.getMonth() + 1) +
      "\\" +
      today.getDate() +
      " - " +
      today.getHours() +
      ":" +
      today.getMinutes();
   return date;
}
